import { render } from "./LayerSwitcherControl.vue?vue&type=template&id=7bea38da&scoped=true"
import script from "./LayerSwitcherControl.vue?vue&type=script&lang=js"
export * from "./LayerSwitcherControl.vue?vue&type=script&lang=js"

import "./LayerSwitcherControl.vue?vue&type=style&index=0&id=7bea38da&scoped=true&lang=css"

import exportComponent from "/home/manohar/Bhutan_gitlab/tethysapp-airqualitybt/tethysapp/airqualitybt/vairqualitybt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bea38da"]])

export default __exports__